"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cavezzo": {
    "94b72492": [{
      "hkey": "54769f5b",
      "slug": "cavezzo",
      "name": "Cavezzo",
      "primary": true,
      "skipSearch": false
    }],
    "botteghino": [{
      "hkey": "54769f5b",
      "slug": "cavezzo",
      "name": "Cavezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b958bd80": [{
      "hkey": "54769f5b",
      "slug": "cavezzo",
      "name": "Cavezzo",
      "primary": true,
      "skipSearch": false
    }],
    "cantone-motta": [{
      "hkey": "54769f5b",
      "slug": "cavezzo",
      "name": "Cavezzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "27de12dc": [{
      "hkey": "27e1abfd",
      "slug": "motta",
      "name": "Motta",
      "primary": true,
      "skipSearch": false
    }],
    "ponte-motta": [{
      "hkey": "27e1abfd",
      "slug": "motta",
      "name": "Motta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "cavezzo"
    }],
    "12cbbecf": [{
      "hkey": "27e1abfd",
      "slug": "motta",
      "name": "Motta",
      "primary": true,
      "skipSearch": false
    }],
    "villa-motta": [{
      "hkey": "27e1abfd",
      "slug": "motta",
      "name": "Motta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;